module.exports = __webpack_public_path__ + "static/img/core-bg-04.a5339df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/core-bg-04.png
// module id = 1S6K
// module chunks = 1